export default [
	{
		path: '/motoristas',
		name: 'drivers.index',
		component: () => import(/* webpackChunkName: "drivers.index" */ './pages/Index.vue')
	}
]